<template>
	<div class="main-containter" id="top" v-title data-title="reservaion">
		<PHeader :checkId="'加入我们34'"  :activeNames="'联系我们'"></PHeader>
		
		<article>
			<div style="height:150px;width:100%">
				<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/otherTitle.png" style="height: 100%;width: 100%;">
				<div class="fbannerUpText" style="position: absolute;top: 120px;color: white;font-weight: 600;font-size: 20px;left: calc(50% - 40px);">加入我们</div>
				<div class="fbannerUpText" style="position: absolute;top: 155px;color: white;font-size: 14px;left: calc(50% - 31px);">Join Us</div>
			</div>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 </span>
				<span style="color:#333333;font-size:14px;"> / 加入我们</span>
			</div>
			<div style="margin-left: 3%;margin-top:0px;text-align:center;width:94%;">
				<div style="height:65px;">
					<div style="width: 150px;text-align: left;margin-top: 5px;">
						<div style="font-size: 18px;font-weight: 900;border-bottom: 3px solid;padding-bottom: 5px;width: 75px;color: rgb(51, 51, 51);">
							社会招聘
						</div>
						<div style="height: 1px; width: 100%; border-top: 1px solid rgb(170, 170, 170);"></div>
					</div>
					<div style="width: 100%;text-align: center;font-size: 14px;color: rgb(51, 51, 51);margin-top: 10px;">
						<span>地区：</span>
						<span @click="changeAddress('')" :style="{color:!address || address == ''?'#98273A':'#333333',padding:'0 10px',cursor:'pointer'}">全部</span>
						<span @click="changeAddress(item)" :style="{color:address == item?'#98273A':'#333333',padding:'0 10px',cursor:'pointer'}" v-for="item in addressList" :key="item">{{item}}</span>
					</div>
				</div>
				<div style="padding-top: 0px;margin-bottom: 20px;">
					<div style="width: 100%;height: 260px;margin-top: 20px;border: 1px solid rgb(215, 215, 215);" v-for="(item,index) in tableData" :key="index">
						<div style="color: rgb(139, 141, 139);font-size: 18px;font-weight: 900;text-align: left;padding: 10px 0 0 10px;cursor: pointer;" @click="toDetail(item,index)">{{item.name}}</div>
						<div style="margin-left: 10px;height: 3px;width: 35px;background-color: rgb(152, 39, 58);margin-top: 5px;"></div>
						<div style="margin-left: 10px;margin-right: 10px;height: 1px;background-color: rgb(170, 170, 170);"></div>
						<div style="margin-top: 15px;margin-left: 10px;margin-right: 10px;">
							<div>
								<span style="float: left;width: 60px;height: 80px;font-size: 14px;font-weight: 900;color: rgb(102, 102, 102);">岗位介绍</span>
								<span style="float: left;padding-left: 10px;height: 80px;text-align: left;width: calc(100% - 70px);color: rgb(102, 102, 102);font-size: 14px;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;">{{item.content}}</span>
							</div>
							<div style="padding-top: 75px;">
								<span style="float: left;width: 60px;height: 30px;font-size: 14px;font-weight: 900;color: rgb(102, 102, 102);">工作地点</span>
								<span style="float: left;text-align: left;padding-left: 10px;height: 30px;width: calc(100% - 70px);color: rgb(102, 102, 102);font-size: 14px;">{{item.address}}</span>
							</div>
							<div style="padding-top: 30px;">
								<span style="float: left;width: 60px;height: 30px;font-size: 14px;font-weight: 900;color: rgb(102, 102, 102);">招聘人数</span>
								<span style="float: left;text-align: left;padding-left: 10px;height: 30px;width: calc(100% - 70px);color: rgb(102, 102, 102);font-size: 14px;">{{item.number}}人</span></div>
							<div @click="toDetail(item)" style="float: left;margin-top: 10px;font-size: 14px;text-align: center;width: 70px;padding: 7px 25px;color: #98273A;border: 1px solid #98273A;border-radius: 50px;cursor: pointer;">
								了解详情
							</div>
						</div>
					</div>
				</div>
			</div>
			<el-pagination
				background
				layout="prev, pager, next"
				:page-size="4"
				:total="total"
				@current-change="handleCurrentChange">
			</el-pagination>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	import {query} from "@/api/joinUs";
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				tableData: [],
				total:0,
				pageNo: 1,
				address:'',
				addressList:[]
			}
		},
		mounted() {
			this.list()
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
			toDetail(item,index){
				this.$router.push(
					{
						path:'/phone/joinUsDetail',
						query:{
							item:JSON.stringify(item),
						}
					}
				);
			},
			handleCurrentChange(page){
				this.pageNo = page
				this.list()
			},
			changeAddress(address){
				this.address = address
				this.pageNo = 1;
				this.list()
			},
			list() {
				let param = {
					name: '',
					address:this.address,
					type:'社会招聘',
					page: this.pageNo,
					pageSize: 4,
				}
				query(param).then(data => {
					this.tableData = data.data.list
					this.total = data.data.total
					this.addressList = data.data.addressList
					// console.log("列表",this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
/* Reset */
 .btn-border-o:before{
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

/* Main Styles */

.btn {
  position: relative;
}

.btn-border-o {
  background-color: transparent;    
  border: 0;
  border-bottom: 1px solid #d0d0d0;
  color: #B8B8B8;
}
.btn-border-o:before {
  content: '';
  border-style: solid;
  position: absolute;
  z-index: 5;
  box-sizing: content-box;
}
.btn-border-o:before {
  width: 0;
  height: 100%;
  border-width: 0 0 1px 0;
  top: -0.5px;
  left: 0;
}
.btn-border-o:hover:before {
  width: 100%;
}
.btn-border-o:hover:after {
  height: 100%;
}
.btn-border-o.btn-green:hover {
  color: #98273A;
}
div ::v-deep .el-pagination.is-background .btn-next:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div ::v-deep .el-pagination.is-background .btn-prev:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div ::v-deep .el-pagination.is-background .btn-prev{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div ::v-deep .el-pagination.is-background .btn-next{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div ::v-deep .el-pagination.is-background .el-pager li{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}

div ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
  /*进行修改选中项背景和字体*/
	background-color: #98273A !important;
  color:white !important;
  border-radius: 2px !important;
  font-weight: 400 !important;
  border: 1px solid #98273A !important;
}

div ::v-deep .el-pagination.is-background .el-pager li:hover{
   color: #98273A !important;/*hover时候的文字颜色*/
 }
div ::v-deep .el-pager li.active{
   color:#98273A !important;/*仅设置active时的文字颜色*/
 }
div ::v-deep .el-pagination{
	text-align: center;
	margin-bottom: 20px;
}
</style>
